import { AnimationClip, AnimationMixer, Mesh, type AnimationAction } from "three";
import type { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

import { disposeObject } from "../utilities/disposeObject";
import { WorldObject } from "../world/WorldObject";
import { CLIP_FADE_SECONDS } from "../renderConstants";

export class AnimatedModel extends WorldObject {
  private readonly clips: AnimationClip[];
  private readonly mixer: AnimationMixer;
  private playingAction: AnimationAction | null = null;

  constructor(gltf: GLTF) {
    super();
    this.clips = gltf.animations;

    gltf.scene.traverse((object) => {
      if (!(object instanceof Mesh)) return;
      object.castShadow = true;
      object.receiveShadow = true;
    });

    this.root.add(gltf.scene);
    this.mixer = new AnimationMixer(gltf.scene);
  }

  playClip(clipName: string | null) {
    this.playingAction?.fadeOut(CLIP_FADE_SECONDS);
    const clip = clipName ? AnimationClip.findByName(this.clips, clipName) : null;
    this.playingAction = clip ? this.mixer.clipAction(clip) : null;
    this.playingAction?.reset().fadeIn(CLIP_FADE_SECONDS).play();
  }

  step(deltaSeconds: number) {
    this.mixer.update(deltaSeconds);
  }

  dispose() {
    this.mixer.stopAllAction();
    this.mixer.uncacheRoot(this.mixer.getRoot());
    disposeObject(this.root);
  }
}
